import { useEffect, useState } from "react";
import styles from "./styles/InputList.module.css";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../utils/utils";
/**
 * Inpur text component
 * ForwardRef is used to focus on the element when mounted since it is a component
 */
const InputList = ({
    label,
    inputId,
    inputValue,
    handleChangeFunction,
    required,
    letterSpacing,
    textAlign,
    values,
    fullWidth,
    disable,
}) => {
    const [currentValue, setCurrentValue] = useState();
    const { t } = useTranslation();

    useEffect(() => {
        setCurrentValue(inputValue);
    }, [inputValue]);

    const handleSelect = (event) => {
        setCurrentValue(event.target.value);
        handleChangeFunction({
            target: { name: inputId, value: event.target.value },
        });
    };

    return (
        <div
            className={`${styles.input_container} ${
                fullWidth ? styles.full_width : ""
            } v-flex-container`}
        >
            {label && (
                <label className={`${styles.input_label}`} htmlFor={inputId}>
                    {label}:
                </label>
            )}
            <select
                className={`${styles.input_element} ${
                    required && styles.alert
                } ${disable ? styles.disabled : ""}`}
                style={{
                    letterSpacing: letterSpacing,
                    textAlign: textAlign,
                }}
                name={inputId}
                id={inputId}
                value={currentValue}
                onChange={handleSelect}
                disabled={disable}
            >
                {values?.map((value) => (
                    <option key={value} value={value}>
                        {capitalizeFirstLetter(t(value.toLowerCase()))}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default InputList;
